import React, { Component } from 'react';
import axios from 'axios';
import { FieldTypes } from 'drapcode-constant';
import { ErrorMessage, Field, getIn } from 'formik';
import { builderSurfaceJsonContentHeader } from '../../../../common/utils/restApiHeaderUtils';
import ItemFormCustomSelect from '../../../../common/formElements/ItemFormCustomSelect';
class Reference extends Component {
  state = { options: [] };

  requiredValidate = (value) => {
    if (this.props.isConstructorForm) {
      return;
    }
    const { required } = this.props.field;
    let error;
    if (required && (!value || value.length === 0)) {
      error = 'This field is required';
    }
    return error;
  };

  componentDidMount() {
    const { field, projectId, version } = this.props;
    if (!field.refCollection) {
      return;
    }

    const header = builderSurfaceJsonContentHeader(this.props.projectId);
    axios
      .get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${this.props.field.refCollection.collectionName}/`,
        header,
      )
      .then((res) => {
        let options1 = [];
        if (Array.isArray(res.data)) {
          options1 = res.data.map((item) => {
            let refCollectionFieldName = this.props.field.refCollection.collectionField;
            const fileTypeRef = this.props.field.refCollection.isFileType;
            const label = _.get(item, refCollectionFieldName);
            let labelText;
            if (fileTypeRef) {
              if (Array.isArray(label)) {
                labelText = label.map((l) => l.uuid).join(', ');
              } else if (typeof label === 'object') {
                labelText = label.uuid;
              }
            } else {
              labelText = label ? label : 'Field value not defined';
            }
            return {
              value: item.uuid,
              label: labelText,
            };
          });
        }

        const options = [{ value: '', label: '-- Select Value --' }].concat(options1);
        this.setState({ options: options });
      });
  }

  render() {
    const { field, values, isConstructorForm } = this.props;
    const { fieldTitle, required, fieldName, type, isMultiSelect } = field;
    const fieldValue = getIn(values, fieldName);
    return (
      <>
        <Field
          as={ItemFormCustomSelect}
          name={fieldName}
          isMulti={isMultiSelect}
          onChange={this.props.setFieldValue}
          onBlur={this.props.setFieldTouched}
          options={this.state.options.length > 0 ? this.state.options : []}
          placeholder={`Please select ${fieldTitle['en']}`}
          value={fieldValue}
          validate={this.requiredValidate}
          title={fieldTitle['en']}
        />
        <p className="errors">
          <ErrorMessage name={field.fieldName} />
        </p>
      </>
    );
  }
}

export default Reference;
